import { Typography, List, ListItem, Avatar } from "@mui/material";
import { Box } from "@mui/system";
import { Fan } from "../models";
import { MouseEvent } from "react";
import { formatDate } from "@arelia-utils/helpers/dates";

type Props = {
  fans: Fan[] | undefined,
  activeFan: Fan | null,
  setActiveFan: (fan: any) => void
};

export default function FansList({ fans, setActiveFan, activeFan }: Props) {
  const showQuickView = (e: MouseEvent<HTMLDivElement>, fan: Fan) => {
    e.stopPropagation();
    setActiveFan(fan);
  }

  return <List>
    {fans && fans.map(fan =>
      <ListItem divider key={fan.id}>
        <Box
          sx={styles.containerBox(activeFan?.id === fan.id)}
          onClick={(e) => showQuickView(e, fan)}
        >
          <Box sx={styles.sectionBox}>
            <Avatar sx={styles.avatar}></Avatar>
            <Typography variant="subtitle2">{fan.fullName}</Typography>
          </Box>
          <Typography sx={styles.centeredTypo} variant="subtitle2">{fan.email}</Typography>
          <Typography sx={styles.centeredTypo} variant="subtitle2">{formatDate(fan.createdAt, "MM/dd/yy hh:mm aa")}</Typography>
        </Box>
      </ListItem>
    )}
  </List>
}

const styles = {
  containerBox(isActive: boolean) {
    return {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px",
      borderRadius: "6px",
      backgroundColor: isActive ? "rgba(6, 178, 218, 0.1)" : "transparent",
      width: "100%",
      '&:hover': {
        backgroundColor: "rgba(6, 178, 218, 0.1)",
        cursor: "pointer"
      }
    };
  },
  avatar: {
    width: "30px",
    height: "30px",
    borderRadius: "30px"
  },
  sectionBox: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  centeredTypo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}